var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 1536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#171717"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1870,
    y: 1210,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1980,
    y: 1180,
    width: 120,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2090,
    y: 1210,
    width: 120,
    height: 250
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.1d4fd23210dd6a973f452f4ea73eba98.svg";
export { ForwardRef as ReactComponent };